export function AutoLiabilityIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" {...props}>
      {/* shield */}
      <path
        d="M24 4L8 12v10c0 11 6.8 18.4 16 22 9.2-3.6 16-11 16-22V12L24 4z"
        fill="#3B82F6"
        opacity="0.15"
      />
      <path
        d="M24 4L8 12v10c0 11 6.8 18.4 16 22 9.2-3.6 16-11 16-22V12L24 4z"
        stroke="#3B82F6"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      {/* car silhouette */}
      <path
        d="M16 26h16M18 22l2-4h8l2 4"
        stroke="#3B82F6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="18" cy="29" r="1.5" fill="#3B82F6" />
      <circle cx="30" cy="29" r="1.5" fill="#3B82F6" />
    </svg>
  )
}
